import { REMOVE_NOTIFICATION } from "./type";

export const removeNotifications = () => ({
    type: REMOVE_NOTIFICATION,
});
